module.exports = "/static/js/8fb32b7df9d23fba6815be264311f8a3.png";